module.exports = __webpack_public_path__ + "static/2.3MoveObjectClose-53803fd6d137b8bacd1daebde73d3021.gif";